import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";

import Preloader from "../../PreloaderGrids/Preloader";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import Pin from "../../../assets/pin.png";

import { FaMap } from "react-icons/fa6";
import { Tooltip } from "@mui/material";

import {
  GridFooterContainer,
  GridPagination,
} from "@mui/x-data-grid";

import BateriaOn from "../../../assets/bateria.png";
import BateriaVerde from "../../../assets/bateria100.png";
import BateriaVermelha from "../../../assets/bateriaMenor_igual5.png";
import BateriaAmarela from "../../../assets/bateriaMenor9.png";
import BateriaOff from "../../../assets/bateriaOff.png";

import { MdGpsFixed, MdGpsOff } from "react-icons/md";
import { IoIosCopy } from "react-icons/io";

import { DataGrid } from "@mui/x-data-grid";
import { GridFooter } from "@mui/x-data-grid";

import { ptBR } from "@mui/x-data-grid";

import api from "../../../services/api";

import { RiFileExcel2Line } from "react-icons/ri";
import { FaRegFilePdf } from "react-icons/fa";
import { TbGps, TbReportAnalytics, TbMap2 } from "react-icons/tb";

import { format } from "date-fns";

import Select from "react-select";

import "./styles.scss";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import ChaveOn from "../../../assets/chaveOn.png";
import ChaveOff from "../../../assets/chaveOff.png";

import SireneOn from "../../../assets/sireneOn.png";
import SireneOff from "../../../assets/sireneOff.png";

import BloqueioOn from "../../../assets/cadeadoOn.png";
import BloqueioOff from "../../../assets/cadeadoOff.png";

import InovaLogo from "../../../assets/aqui.jpg";

import googleMapsUrl from "../../GoogleMaps/GoogleMaps";

import RoomIcon from "@mui/icons-material/Route";

import Swal from "sweetalert2";

import DatePicker, { registerLocale, setDefaultLocale, } from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import { ptBR as ptBRDateFns } from "date-fns/locale/pt-BR";






// CACHE DE ICONES SVG PARA NAO RECRIAR MILHARES DE VEZES
const iconCache = {};

function getIcon(svg) {
  if (!iconCache[svg]) {
    iconCache[svg] = {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
      scaledSize: new window.google.maps.Size(80, 50)
    };
  }
  return iconCache[svg];
}



function CustomFooter({ kmTotal }) {

  return (
    <GridFooterContainer
      className="inova-grid-footer"
      sx={{
        minHeight: 64,
        px: 2.5,
        py: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#FFFFFF",
        borderTop: "1px solid #E5EAF0",
        gap: 2,
      }}
    >
      {/* DISTÂNCIA PERCORRIDA */}
      <div className="inova-grid-footer__total">

        <div className="inova-grid-footer__info">
          <span className="inova-grid-footer__label">
            Distância percorrida
          </span>

          <div className="inova-grid-footer__value">
            <span>{kmTotal.toFixed(2)}</span>
            <span className="inova-grid-footer__unit">km</span>
          </div>
        </div>
      </div>

      {/* PAGINAÇÃO */}
      <div className="inova-grid-footer__pagination">
        <GridPagination />
      </div>
    </GridFooterContainer>
  );
}
function Posicao() {
  const { tipo } = useParams();
  const titulos = { posicao: "Relatório de Posição", motorista: "Relatório de Motorista", produtividade: "Relatório de Produtividade" };
  const ehPosicao = tipo === "posicao";
  const ehMotorista = tipo === "motorista";
  const hoje = new Date().toISOString().split("T")[0]; // Obtém a data atual no formato YYYY-MM-DD
  const XLSX = require("xlsx");
  const [de, setDe] = useState(hoje);
  const [ate, setAte] = useState(hoje);
  const [horaDe, setHoraDe] = useState("00:00");
  const [horaAte, setHoraAte] = useState("23:59");
  const [velocidade, setVelocidade] = useState("0");
  const [intervaloDeMin, setIntervaloDeMin] = useState("tudo");
  const [ignicao, setIgnicao] = useState("tudo");
  const [placa, setPlaca] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [dadosTabela, setDadosTabela] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);
  const [loadingText, setLoadingText] = useState("Carregando página de relatório...");
  const rotaAjustada = React.useRef(false);
  const [erroHoraDe, setErroHoraDe] = useState("");
  const [erroHoraAte, setErroHoraAte] = useState("");
  const id = localStorage.getItem("cliente_id");
  const [pdfHabilitado, setPdfHabilitado] = useState(false);
  const [acaoCarregando, setAcaoCarregando] = useState(null);

  const [tracarSeta, setTracarSeta] = useState("sim");
  const [tracarLinha, setTracarLinha] = useState("sim");
  const [marcadores, setMarcadores] = useState([]);
  const [clienteNome, setClienteNome] = useState("");
  const [modo, setModo] = useState("");
  const [mapReady, setMapReady] = useState(false);
  const mapContainerRef = React.useRef(null);
  console.log(`marcadores`, marcadores)
  registerLocale("pt-BR", ptBRDateFns);
  setDefaultLocale("pt-BR");

  //ALTERANDO BODY DA PÁGINA
  useEffect(() => {
    document.body.classList.add("body-relatorio");

    return () => {
      document.body.classList.remove("body-relatorio");
    };
  }, []);



  useEffect(() => {
    const dadosVeiculo = sessionStorage.getItem("relatorio_veiculo");

    if (!dadosVeiculo) {
      return;
    }

    try {
      const veiculo = JSON.parse(dadosVeiculo);

      console.log("🚗 VEÍCULO RECUPERADO:", veiculo);

      if (veiculo?.placa) {
        setPlaca({
          value: veiculo.placa,
          label: veiculo.placa,
          placa: veiculo.placa,
          nome: veiculo.descricao || "",
        });
      }
    } catch (error) {
      console.error(
        "Erro ao recuperar veículo do relatório:",
        error
      );
    }
  }, []);

  // Guarda o mapa
  const mapRef = React.useRef(null);

  // Guarda os marcadores atuais
  const markersRef = React.useRef([]);

  // Guarda as posições retornadas da API
  const [posicoes, setPosicoes] = useState([]);

  //calcular o angulo entre dois pontos para a seta do mapa
  function calcularAngulo(p1, p2) {
    const lat1 = p1.lat * Math.PI / 180;
    const lat2 = p2.lat * Math.PI / 180;
    const deltaLng = (p2.lng - p1.lng) * Math.PI / 180;

    const y = Math.sin(deltaLng) * Math.cos(lat2);
    const x =
      Math.cos(lat1) * Math.sin(lat2) -
      Math.sin(lat1) * Math.cos(lat2) * Math.cos(deltaLng);

    let angulo = Math.atan2(y, x) * (180 / Math.PI);
    return (angulo + 360) % 360;
  }


  //CRIANDO PONTOS INTERMEDIARIOS PARA O RELATÓRIO DE ROTA

  function densificarRota(pontos, subdivisoes = 10) {

    const novaRota = [];

    for (let i = 0; i < pontos.length - 1; i++) {

      const atual = pontos[i];
      const proximo = pontos[i + 1];

      novaRota.push(atual);

      for (let j = 1; j < subdivisoes; j++) {

        const t = j / subdivisoes;

        novaRota.push({
          lat: atual.lat + (proximo.lat - atual.lat) * t,
          lng: atual.lng + (proximo.lng - atual.lng) * t
        });

      }
    }

    novaRota.push(pontos[pontos.length - 1]);

    return novaRota;
  }





  //=============================================================================================
  //COLETA INFO DOS FILTROS E ENVIA PARA O BACKEND, RECEBE AS POSIÇÕES  NO MAPA 
  //==============================================================================================


  const handleSubmit = async (
    modoExecucao = "ROTA",
    event = null
  ) => {
    if (event) event.preventDefault();

    if (acaoCarregando !== null) return;

    setAcaoCarregando(modoExecucao);

    let abaPDF = null;

    try {
      // =====================================================
      // VALIDAÇÃO DA PLACA
      // =====================================================

      if (!placa?.value) {
        await Swal.fire({
          icon: "warning",
          title: "Selecione uma placa",
          text: "Escolha um veículo para continuar.",
          confirmButtonText: "OK",
          background: "#0b1f2d",
          color: "#f1f5f9",
          width: "360px",
          padding: "28px",
          scrollbarPadding: false,
          heightAuto: false,
          customClass: {
            popup: "inova-swal",
            title: "inova-swal-title",
            confirmButton: "inova-swal-button",
          },
          buttonsStyling: false,
        });

        return;
      }

      // =====================================================
      // VALIDAR DATAS E PERÍODO MÁXIMO DE 2 MESES
      // =====================================================

      const dataInicial = new Date(`${de}T00:00:00`);
      const dataFinal = new Date(`${ate}T00:00:00`);

      if (
        !de ||
        !ate ||
        Number.isNaN(dataInicial.getTime()) ||
        Number.isNaN(dataFinal.getTime()) ||
        dataInicial > dataFinal
      ) {
        await Swal.fire({
          icon: "warning",
          title: "Período inválido",
          text: "Informe uma data inicial e final válidas.",
          background: "#0b1f2d",
          color: "#fff",
          confirmButtonText: "Entendi",
          buttonsStyling: false,
          customClass: {
            popup: "produtividade-swal",
            icon: "produtividade-swal-icon",
            title: "produtividade-swal-title",
            htmlContainer: "produtividade-swal-text",
            confirmButton: "produtividade-swal-button",
          },
        });

        return;
      }

      const limitePeriodo = new Date(dataInicial);
      limitePeriodo.setMonth(limitePeriodo.getMonth() + 2);

      if (dataFinal > limitePeriodo) {
        await Swal.fire({
          icon: "warning",
          title: "Período máximo excedido",
          text: "O relatório permite consultar no máximo 2 meses por vez.",
          background: "#0b1f2d",
          color: "#fff",
          confirmButtonText: "Entendi",
          buttonsStyling: false,
          customClass: {
            popup: "produtividade-swal",
            icon: "produtividade-swal-icon",
            title: "produtividade-swal-title",
            htmlContainer: "produtividade-swal-text",
            confirmButton: "produtividade-swal-button",
          },
        });

        return;
      }

      // =====================================================
      // VELOCIDADE
      // =====================================================

      const velocidadeFiltro =
        velocidade === "0" ? 0 : velocidade;

      // =====================================================
      // CONSULTAR POSIÇÕES ATUALIZADAS
      // =====================================================

      const response = await api.get(
        `/relatorioListPlaca/${placa.value}?de=${de}&ate=${ate}&intervaloDeMin=${intervaloDeMin}&horaDe=${horaDe}&horaAte=${horaAte}&ignicao=${ignicao}&velocidade=${velocidadeFiltro}`
      );

      const dados = response.data.data;

      const dadosRelatorio = Array.isArray(dados)
        ? dados
        : [];

      // =====================================================
      // VERIFICAR ÚLTIMA POSIÇÃO
      // =====================================================

      if (dadosRelatorio.length > 0) {
        const ultimaPosicao = new Date(
          dadosRelatorio[0].posicao_em
        );

        const dataUltima = format(
          ultimaPosicao,
          "dd/MM/yyyy HH:mm:ss"
        );

        const dataFimSelecionada = new Date(
          `${ate}T${horaAte || "23:59"}:00`
        );
      }

      // =====================================================
      // ATUALIZAR POSIÇÕES NA TELA
      // =====================================================

      setPosicoes(
        dadosRelatorio.map((item, index) => ({
          ...item,
          id: index,
        }))
      );

      // =====================================================
      // HABILITAR OU BLOQUEAR PDF
      // =====================================================

      setPdfHabilitado(dadosRelatorio.length > 0);

      // =====================================================
      // VALIDAR DADOS PARA EXPORTAÇÃO
      // =====================================================

      if (
        (modoExecucao === "PDF" ||
          modoExecucao === "Excel") &&
        dadosRelatorio.length === 0
      ) {
        await Swal.fire({
          icon: "info",
          title: "Nenhum registro encontrado",
          text: "Não existem posições para os filtros selecionados.",
          confirmButtonText: "Entendi",
          customClass: {
            popup: "inova-swal",
            title: "inova-swal-title",
            confirmButton: "inova-swal-button",
          },
          background: "#0b1f2d",
          color: "#dbe5ed",
          buttonsStyling: false,
          scrollbarPadding: false,
          heightAuto: false,
        });

        return;
      }

      // =====================================================
      // PDF — SOMENTE NO BOTÃO PDF
      // =====================================================

      if (modoExecucao === "PDF") {
        await generatePDF();
        return;
      }

      // =====================================================
      // EXCEL
      // =====================================================

      if (modoExecucao === "Excel") {
        await exportarDados(
          dadosRelatorio,
          modoExecucao
        );

        return;
      }

      // =====================================================
      // ROTA — ROLAR ATÉ O MAPA
      // =====================================================

      if (modoExecucao === "ROTA") {
        if (dadosRelatorio.length === 0) {
          await Swal.fire({
            icon: "info",
            title: "Nenhuma posição encontrada",
            text: "Não existem posições para exibir no mapa com os filtros selecionados.",
            confirmButtonText: "Entendi",
            background: "#0b1f2d",
            color: "#dbe5ed",
            buttonsStyling: false,
            scrollbarPadding: false,
            heightAuto: false,
            customClass: {
              popup: "inova-swal",
              title: "inova-swal-title",
              confirmButton: "inova-swal-button",
            },
          });

          return;
        }

        // Aguarda o React renderizar as posições antes de rolar.
        requestAnimationFrame(() => {
          setTimeout(() => {
            const mapa = mapContainerRef.current;

            if (!mapa) {
              console.warn(
                "Não foi possível localizar o elemento do mapa."
              );
              return;
            }

            mapa.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });

            // Compensa o espaço ocupado pelo cabeçalho.
            setTimeout(() => {
              window.scrollBy({
                top: -80,
                behavior: "smooth",
              });
            }, 350);
          }, 300);
        });
      }
    } catch (error) {
      console.error("Erro ao enviar os dados:", error);

      setPdfHabilitado(false);

      if (abaPDF && !abaPDF.closed) {
        abaPDF.close();
      }

      await Swal.fire({
        icon: "error",
        title: "Erro ao consultar relatório",
        text:
          error?.response?.data?.erro ||
          "Não foi possível carregar as posições.",
        confirmButtonText: "Entendi",
        customClass: {
          popup: "inova-swal",
          title: "inova-swal-title",
          confirmButton: "inova-swal-button",
        },
        background: "#0b1f2d",
        color: "#dbe5ed",
        buttonsStyling: false,
        scrollbarPadding: false,
        heightAuto: false,
      });
    } finally {
      setLoading(false);
      setAcaoCarregando(null);
    }
  };









  const loadGoogleMapScript = () => {
    const googleMapScript = document.createElement("script");

    googleMapScript.src = googleMapsUrl;
    googleMapScript.async = true;
    googleMapScript.defer = true;

    document.body.appendChild(googleMapScript);





  };

  // GERAR PDF | EXCEL
  const exportarDados = (dados, modoExecucao) => {

    if (modoExecucao === "PDF") {
      generatePDF(dados, kmTotal);


    }

    if (modoExecucao === "Excel") {
      generateExcel(dados, kmTotal);
    }

  };
  //===================================
  //LIMITAR DATA PARA NAO QUEBRAR A API
  const LIMITE_DIAS = 32;
  //===================================


  //==============================
  //MAPA E CONFIGURAÇÕES INICIAIS
  //==============================
  useEffect(() => {

    window.initMap = () => {

      const mapOptions = {

        center: { lat: -23.55052, lng: -46.633308 },

        zoom: 9,
        maxZoom: 22,
        minZoom: 3,

        // tipo inicial
        mapTypeId: window.google.maps.MapTypeId.ROADMAP,

        // CONTROLES
        zoomControl: true,
        mapTypeControl: true, // libera troca de mapa
        streetViewControl: true,
        fullscreenControl: true,

        // opções de mapa disponíveis
        mapTypeControlOptions: {
          style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: window.google.maps.ControlPosition.TOP_RIGHT,
          mapTypeIds: [
            "roadmap",
            "satellite",
            "hybrid",
            "terrain"
          ]
        },

        // scroll
        gestureHandling: "greedy",
        scrollwheel: true,

        // navegação
        keyboardShortcuts: true,

        restriction: {
          latLngBounds: {
            north: 85,
            south: -85,
            west: -179.999,
            east: 179.999
          },
          strictBounds: false
        }

      };

      const map = new window.google.maps.Map(
        document.getElementById("map"),
        mapOptions
      );

      mapRef.current = map;

      // trava longitude extrema
      map.addListener("idle", () => {

        const center = map.getCenter();
        let lng = center.lng();

        if (lng < -179.9) {
          map.panTo({ lat: center.lat(), lng: -179.9 });
        }

        if (lng > 179.9) {
          map.panTo({ lat: center.lat(), lng: 179.9 });
        }

      });

      setMapReady(true);

    };

    loadGoogleMapScript();


  }, []);



  //DADOS COMPLETOS PLACAS
  useEffect(() => {
    async function fetchData() {
      const id = localStorage.getItem("id");
      console.log("ID from localStorage:", id);
      const { data } = await api.get(`/relatorioListInfo/${id}`, {
        headers: {
          typo: id, // Se realmente precisar desse cabeçalho
        },

      });
      setMarcadores(data);
      if (data.length > 0) {
        setClienteNome(data[0].nome); // Assumindo que o nome do cliente está presente nos dados retornados
      }
    }

    fetchData();
  }, []);














  //==================================================
  // CRIANDO MARCADORES NO MAPA
  //==================================================
  useEffect(() => {
    let ultimoTempoSeta = null;
    const intervaloSeta = 90; // segundos

    if (!mapReady) return;
    if (!posicoes || posicoes.length === 0) return;
    if (!mapRef.current || !window.google?.maps) return;

    // ======================================================
    // LIMPAR MARCADORES E ROTAS ANTIGAS
    // ======================================================

    markersRef.current.forEach((marker) => marker.setMap(null));
    markersRef.current = [];

    // ======================================================
    // LINHA ÚNICA DA ROTA — VISUAL PREMIUM INOVA
    // Mantém as cores operacionais das setas inalteradas
    // ======================================================

    const path = posicoes
      .filter((p) => {
        if (
          p.lat === null ||
          p.lat === undefined ||
          p.lat === "" ||
          p.lon === null ||
          p.lon === undefined ||
          p.lon === ""
        ) {
          return false;
        }

        return (
          Number.isFinite(Number(p.lat)) &&
          Number.isFinite(Number(p.lon)) &&
          Number(p.lat) >= -90 &&
          Number(p.lat) <= 90 &&
          Number(p.lon) >= -180 &&
          Number(p.lon) <= 180
        );
      })
      .map((p) => ({
        lat: Number(p.lat),
        lng: Number(p.lon),
      }));

    if (path.length >= 2) {
      const linhaRota = new window.google.maps.Polyline({
        path,
        geodesic: true,

        // Azul sofisticado
        strokeColor: "#2563EB",

        // Transparência para não esconder as ruas
        strokeOpacity: 0.82,

        // Traçado mais fino e elegante
        strokeWeight: 3,

        clickable: false,
        zIndex: 10,
      });

      linhaRota.setMap(mapRef.current);
      markersRef.current.push(linhaRota);
    }

    // ======================================================
    // LIMITES DO MAPA
    // ======================================================

    const bounds = new window.google.maps.LatLngBounds();

    // ======================================================
    // MARCADORES, DIREÇÃO E INFORMAÇÕES
    // ======================================================

    for (let i = 0; i < posicoes.length - 1; i++) {
      const atual = posicoes[i];
      const proximo = posicoes[i + 1];

      if (
        atual.lat === null ||
        atual.lat === undefined ||
        atual.lat === "" ||
        atual.lon === null ||
        atual.lon === undefined ||
        atual.lon === "" ||
        proximo.lat === null ||
        proximo.lat === undefined ||
        proximo.lat === "" ||
        proximo.lon === null ||
        proximo.lon === undefined ||
        proximo.lon === ""
      ) {
        continue;
      }

      const p1 = {
        lat: Number(atual.lat),
        lng: Number(atual.lon),
      };

      const p2 = {
        lat: Number(proximo.lat),
        lng: Number(proximo.lon),
      };

      if (
        !Number.isFinite(p1.lat) ||
        !Number.isFinite(p1.lng) ||
        !Number.isFinite(p2.lat) ||
        !Number.isFinite(p2.lng) ||
        Math.abs(p1.lat) > 90 ||
        Math.abs(p2.lat) > 90 ||
        Math.abs(p1.lng) > 180 ||
        Math.abs(p2.lng) > 180
      ) {
        continue;
      }

      bounds.extend(p1);
      bounds.extend(p2);

      // ====================================================
      // CORES OPERACIONAIS DAS SETAS — PRESERVADAS
      // ====================================================

      const corLinha = "#2563EB";

      let corSeta = "#1565C0";

      const ign = parseInt(atual.ignicao ?? 0, 10);
      const vel = parseFloat(atual.velocidade ?? 0);

      if (ign === 0 && vel < 4) {
        corSeta = "#D50000";
      } else if (ign === 0 && vel >= 4) {
        corSeta = "#ff4d00";
      } else if (ign >= 1 && vel >= 4) {
        corSeta = "#0b5b80";
      } else if (ign >= 1 && vel < 4) {
        corSeta = "#FBC02D";
      }

      // ====================================================
      // CONVERSÃO DO CURSO PARA ÂNGULO
      // ====================================================

      function converterCursoParaAngulo(curso) {
        switch (parseInt(curso, 10)) {
          case 0:
            return 0; // Norte
          case 1:
            return 45; // Nordeste
          case 2:
            return 90; // Leste
          case 3:
            return 135; // Sudeste
          case 4:
            return 180; // Sul
          case 5:
            return 225; // Sudoeste
          case 6:
            return 270; // Oeste
          case 7:
            return 315; // Noroeste
          default:
            return 0;
        }
      }



      const scrollToMap = () => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            const mapa = mapContainerRef.current;
            if (!mapa) return;

            mapa.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 300);
        });
      };

      // ====================================================
      // HORÁRIO E SETA DIRECIONAL
      // ====================================================

      const hora = new Date(atual.posicao_em).toLocaleTimeString(
        "pt-BR",
        {
          hour: "2-digit",
          minute: "2-digit",
        }
      );

      const angulo = converterCursoParaAngulo(atual.curso) - 90;

      const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="50">

        <rect
          x="10"
          y="25"
          width="60"
          height="20"
          rx="6"
          ry="6"
          fill="rgba(255, 255, 255, 0.65)"
        />

        <text
          x="40"
          y="40"
          text-anchor="middle"
          font-size="14"
          font-weight="lighter"
          fill="#000000"
        >${hora}</text>

        <g transform="rotate(${angulo} 40 20)">

          <polygon
            points="26,8 54,20 26,32 34,20"
            fill="rgba(0,0,0,0.25)"
            transform="translate(1,2)"
          />

          <polygon
            points="26,8 54,20 26,32 34,20"
            fill="${corSeta}"
          />

          <polygon
            points="30,12 48,20 30,28 34,20"
            fill="rgba(255,255,255,0.25)"
          />

        </g>
      </svg>
    `;

      // ====================================================
      // CRIAR MARCADOR
      // ====================================================

      const setaMarker = new window.google.maps.Marker({
        position: p1,
        map: mapRef.current,
        icon: getIcon(svg),
        zIndex: 999,
      });

      markersRef.current.push(setaMarker);

      // ====================================================
      // STATUS DO VEÍCULO — PRESERVADO
      // ====================================================

      let statusTexto = "";
      let statusCor = "";

      if (ign === 0 && vel < 4) {
        statusTexto = "Parado";
        statusCor = "#D50000";
      } else if (ign === 0 && vel >= 4) {
        statusTexto = "Movimento sem ignição";
        statusCor = "#ff4d00";
      } else if (ign >= 1 && vel >= 4) {
        statusTexto = "Em movimento";
        statusCor = "#0b5b80";
      } else if (ign >= 1 && vel < 4) {
        statusTexto = "Ligado";
        statusCor = "#FBC02D";
      }

      // ====================================================
      // POPUP AO CLICAR NA SETA
      // ====================================================

      const infoWindow = new window.google.maps.InfoWindow();

      setaMarker.addListener("click", () => {
        infoWindow.setContent(`
        <div style="
          width:360px;
          font-family:Inter, Segoe UI, system-ui;
          border-radius:4px;
          overflow:hidden;
          box-shadow:0 10px 25px rgba(0,0,0,0.25);
          background:white;
        ">

          <div style="
            background:#0b2a3c;
            color:white;
            padding:12px 16px;
            display:flex;
            justify-content:space-between;
            align-items:center;
          ">

            <div style="display:flex;align-items:center;gap:8px">

              <span style="
                font-size:17px;
                font-weight:700;
                letter-spacing:0.5px;
              ">
                ${atual.placa}
              </span>

              <span style="
                font-size:12px;
                padding:4px 10px;
                border-radius:20px;
                background:${statusCor};
                color:white;
                font-weight:600;
              ">
                ${statusTexto}
              </span>

            </div>

            <span id="closePopup" style="
              cursor:pointer;
              font-size:18px;
              opacity:.8;
            ">
              ✕
            </span>

          </div>

          <div style="padding:18px;font-size:14px">

            <div style="
              display:grid;
              grid-template-columns:1fr auto;
              row-gap:10px;
              column-gap:20px;
              line-height:1.6;
            ">

              <span style="color:#6b7280">Velocidade</span>

              <span style="
                font-weight:700;
                color:${statusCor};
              ">
                ${atual.velocidade} km/h
              </span>

              <span style="color:#6b7280">Satélites</span>
              <span style="font-weight:600">${atual.satelites}</span>

              <span style="color:#6b7280">Direção</span>
              <span style="font-weight:600">
                ${converterCurso(atual.curso, "nome")}
              </span>

              <span style="color:#6b7280">Bateria</span>
              <span style="font-weight:600">
                ${Number(atual.bateria).toFixed(1)} V
              </span>

              <span style="color:#6b7280">Data</span>

              <span style="font-weight:600">
                ${new Date(atual.posicao_em).toLocaleDateString("pt-BR")}
                •
                ${new Date(atual.posicao_em).toLocaleTimeString(
          "pt-BR",
          {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          }
        )}
              </span>

            </div>

            <div style="
              margin-top:14px;
              padding-top:12px;
              border-top:1px solid #eee;
              color:#374151;
              font-size:13px;
              line-height:1.5;
            ">
              📍 ${atual.endereco}
            </div>

            <div style="
              margin-top:14px;
              display:flex;
              gap:8px;
            ">

              <a
                href="https://www.google.com/maps?q=${atual.lat},${atual.lon}"
                target="_blank"
                rel="noopener noreferrer"
                style="
                  flex:1;
                  text-align:center;
                  padding:8px;
                  border-radius:6px;
                  background:#2563eb;
                  color:white;
                  font-size:13px;
                  text-decoration:none;
                  font-weight:600;
                "
              >
                Abrir no Maps
              </a>

            </div>

          </div>
        </div>
      `);

        infoWindow.open(mapRef.current, setaMarker);

        window.google.maps.event.addListenerOnce(
          infoWindow,
          "domready",
          () => {
            const btn = document.getElementById("closePopup");

            if (btn) {
              btn.onclick = () => infoWindow.close();
            }
          }
        );
      });
    }

    // ======================================================
    // AJUSTAR ZOOM
    // ======================================================

    if (!rotaAjustada.current && !bounds.isEmpty()) {
      mapRef.current.fitBounds(bounds);
      rotaAjustada.current = true;
    }
  }, [posicoes, mapReady]);




  // opções de placa
  const handleChangePlaca = (selectedOption) => {
    setPlaca(selectedOption);
  };


  // GERADOR DE PDF - RELATÓRIO DE POSIÇÃO
  const generatePDF = async () => {

    try {

      // =========================================================
      // VALIDAR VEÍCULO
      // =========================================================

      if (!placa?.value) {

        Swal.fire({
          icon: "warning",
          title: "Selecione uma placa",
          text: "Escolha um veículo para gerar o relatório.",
          background: "#0f172a",
          color: "#fff",
          confirmButtonColor: "#f59e0b",
        });

        return;
      }







      // =========================================================
      // TOKEN
      // =========================================================



      console.log("=================================");
      console.log("LOCAL STORAGE");
      console.log("=================================");

      const dadosLocalStorage = {};

      for (let i = 0; i < localStorage.length; i++) {
        const chave = localStorage.key(i);

        if (chave) {
          dadosLocalStorage[chave] = localStorage.getItem(chave);
        }
      }

      console.log(dadosLocalStorage);
      console.log("=================================");

      const token = localStorage.getItem("id");

      console.log("TOKEN USADO NO PDF:", token);

      if (!token) {
        Swal.fire({
          icon: "error",
          title: "Cliente não identificado",
          text: "Não foi possível identificar o cliente.",
          background: "#0f172a",
          color: "#fff",
          confirmButtonColor: "#ef4444",
        });

        return;
      }


      // =========================================================
      // ABRIR NOVA ABA
      // =========================================================

      const novaAba =
        window.open("", "_blank");


      if (!novaAba) {

        Swal.fire({
          icon: "warning",
          title: "Nova aba bloqueada",
          text: "Permita pop-ups para visualizar o relatório.",
          background: "#0f172a",
          color: "#fff",
          confirmButtonColor: "#f59e0b",
        });

        return;
      }


      // =========================================================
      // LOADING NA NOVA ABA
      // =========================================================

      novaAba.document.write(`

      <!DOCTYPE html>

      <html lang="pt-BR">

      <head>

        <meta charset="UTF-8">

        <title>
          Gerando relatório...
        </title>

        <style>

          * {
            box-sizing: border-box;
          }

          html,
          body {

            margin: 0;

            width: 100%;
            height: 100%;

            font-family:
              Arial,
              Helvetica,
              sans-serif;

            background:
              #0b1220;
          }

          body {

            display: flex;

            align-items: center;

            justify-content: center;
          }

          .loading-container {

            width: 380px;

            padding:
              42px
              35px;

            text-align: center;

            border-radius: 18px;

            background:
              linear-gradient(
                145deg,
                #111c2d,
                #0d1726
              );

            border:
              1px solid
              rgba(255,255,255,.08);

            box-shadow:
              0 25px 70px
              rgba(0,0,0,.45);
          }

          .spinner {

            width: 48px;

            height: 48px;

            margin:
              0
              auto
              25px;

            border-radius: 50%;

            border:
              3px solid
              rgba(255,255,255,.10);

            border-top-color:
              #0b73b5;

            animation:
              spin
              .8s
              linear
              infinite;
          }

          @keyframes spin {

            to {
              transform:
                rotate(360deg);
            }

          }

          .title {

            font-size: 20px;

            font-weight: 700;

            color:
              #ffffff;

            margin-bottom: 8px;
          }

          .text {

            font-size: 13px;

            color:
              #94a3b8;

            line-height: 1.5;
          }

          .brand {

            margin-top: 25px;

            font-size: 10px;

            color:
              #4d87ad;

            letter-spacing: 1.2px;

            text-transform:
              uppercase;
          }

        </style>

      </head>

      <body>

        <div class="loading-container">

          <div class="spinner"></div>

          <div class="title">
            Gerando relatório
          </div>

          <div class="text">

            Estamos preparando seu PDF.<br>

            Isso pode levar alguns segundos...

          </div>

          <div class="brand">
            Relatório de Posição
          </div>

        </div>

      </body>

      </html>

    `);

      novaAba.document.close();


      // =========================================================
      // FORM POST
      // =========================================================

      const form =
        novaAba.document.createElement("form");


      form.method =
        "POST";


      form.action =
        `${api.defaults.baseURL}/posicaoPDF`;


      form.style.display =
        "none";


      // =========================================================
      // FUNÇÃO PARA CRIAR INPUT
      // =========================================================

      const adicionarCampo = (
        nome,
        valor
      ) => {

        const input =
          novaAba.document.createElement(
            "input"
          );

        input.type =
          "hidden";

        input.name =
          nome;

        input.value =
          valor ?? "";

        form.appendChild(
          input
        );

      };


      // =========================================================
      // CAMPOS
      // =========================================================

      adicionarCampo(
        "token",
        token
      );

      adicionarCampo(
        "placa",
        placa?.value
      );

      adicionarCampo(
        "de",
        de
      );

      adicionarCampo(
        "ate",
        ate
      );

      adicionarCampo(
        "horaDe",
        horaDe || "00:00"
      );

      adicionarCampo(
        "horaAte",
        horaAte || "23:59"
      );

      adicionarCampo(
        "intervaloDeMin",
        intervaloDeMin || "tudo"
      );

      adicionarCampo(
        "ignicao",
        ignicao || "tudo"
      );

      adicionarCampo(
        "velocidade",
        velocidade === "0"
          ? "0"
          : velocidade || "0"
      );

      adicionarCampo(
        "tipo",
        tipo || ""
      );


      // =========================================================
      // DEBUG
      // =========================================================

      console.log(
        "================================="
      );

      console.log(
        "POST /posicaoPDF"
      );

      console.log(
        "Token:",
        token
      );

      console.log(
        "Placa:",
        placa?.value
      );

      console.log(
        "Período:",
        de,
        "até",
        ate
      );

      console.log(
        "Horário:",
        horaDe,
        "até",
        horaAte
      );

      console.log(
        "Intervalo:",
        intervaloDeMin
      );

      console.log(
        "Ignição:",
        ignicao
      );

      console.log(
        "Velocidade:",
        velocidade
      );

      console.log(
        "================================="
      );


      // =========================================================
      // ADICIONAR FORM
      // =========================================================

      novaAba.document.body.appendChild(
        form
      );


      // =========================================================
      // ENVIAR
      // =========================================================

      form.submit();


      // =========================================================
      // LOADING NO SISTEMA PRINCIPAL
      // =========================================================

      Swal.fire({

        html: `

        <div class="swal-pdf-loading">

          <div class="swal-pdf-loading-spinner"></div>

          <div class="swal-pdf-loading-title">
            Gerando PDF
          </div>

          <div class="swal-pdf-loading-text">
            Preparando seu relatório...
          </div>

        </div>

      `,

        allowOutsideClick:
          false,

        allowEscapeKey:
          false,

        showConfirmButton:
          false,

        timer:
          900,

        customClass: {

          popup:
            "swal-pdf-loading-popup",

          htmlContainer:
            "swal-pdf-loading-html",

        },

      });


    } catch (error) {

      console.error(
        "Erro ao gerar PDF:",
        error
      );

      Swal.fire({

        icon: "error",

        title:
          "Erro ao gerar PDF",

        text:
          "Não foi possível gerar o relatório de posição.",

        background:
          "#0f172a",

        color:
          "#fff",

        confirmButtonColor:
          "#ef4444",

      });

    }

  };





  const generateExcel = (data, kmTotal) => {

    const workbook = XLSX.utils.book_new();

    const dataInicio = format(new Date(`${de} ${horaDe}`), "dd/MM/yyyy HH:mm");
    const dataFim = format(new Date(`${ate} ${horaAte}`), "dd/MM/yyyy HH:mm");

    const descricao = data?.[0]?.obs || "-";
    const placaVeiculo = data?.[0]?.placa || "-";
    const totalPosicoes = data.length;

    const worksheetData = [];

    // ===== TÍTULO =====
    worksheetData.push(["HISTÓRICO DE POSIÇÃO"]);
    worksheetData.push(["Inova Rastreamento"]);
    worksheetData.push([`${dataInicio} até ${dataFim}`]);
    worksheetData.push([`PLACA: ${placaVeiculo} | DESCRIÇÃO: ${descricao}`]);
    worksheetData.push([`TOTAL DE POSIÇÕES: ${totalPosicoes} | TOTAL KM: ${kmTotal.toFixed(2)} Km`]);
    worksheetData.push([]);

    // ===== CABEÇALHO =====
    const headers = [
      "Data/Hora",
      "Placa",
      "Lat/Long",
      "Endereço",
      "Status",
      "KM/h",
      "Bateria"
    ];

    worksheetData.push(headers);

    // ===== DADOS =====
    data.forEach((item) => {

      const status =
        `Ignição: ${item.ignicao === 1 ? "Ligado" : "Desligado"} | ` +
        `Bloqueio: ${item.bloqueio === 1 ? "Ativo" : "Inativo"} | ` +
        `Sirene: ${item.sirene === 1 ? "Ativa" : "Inativa"}`;

      worksheetData.push([
        format(new Date(item.posicao_em), "dd/MM/yyyy HH:mm:ss"),
        item.placa,
        `${Number(item.lat).toFixed(6)}, ${Number(item.lon).toFixed(6)}`,
        item.endereco || "-",
        status,
        `${item.velocidade} Km/h`,
        `${Number(item.bateria).toFixed(2)} V`
      ]);

    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // ===== TAMANHO DAS COLUNAS =====
    worksheet["!cols"] = [
      { wch: 22 },
      { wch: 12 },
      { wch: 28 },
      { wch: 65 },
      { wch: 40 },
      { wch: 10 },
      { wch: 12 }
    ];

    // ===== CONGELAR HEADER =====
    worksheet["!freeze"] = { xSplit: 0, ySplit: 6 };

    // ===== FILTRO AUTOMÁTICO =====
    worksheet["!autofilter"] = { ref: "A7:G7" };

    XLSX.utils.book_append_sheet(workbook, worksheet, "Relatório");

    XLSX.writeFile(workbook, `Relatorio_Veiculo_${placaVeiculo}.xlsx`);

  };

  const handleModeChange = (value) => {
    setModo(value);
    handleSubmit();
  };



  //==============================================
  //OPÇÕES DE FILTRO PARA A CONSULTA DE INTERVALOS
  //===============================================
  const intervaloOptions = [
    { value: "tudo", label: "Tudo" },
    { value: "10", label: "10 min" },
    { value: "20", label: "20 min" },
    { value: "30", label: "30 min" },
    { value: "60", label: "60 min" },
    { value: "120", label: "2 Horas" },
    { value: "180", label: "3 Horas" },
    { value: "240", label: "4 Horas" },
    { value: "360", label: "6 Horas" },
    { value: "480", label: "8 Horas" },
  ];


  //==============================================
  //OPÇÕES DE FILTRO PARA A CONSULTA DE IGNIÇÃO
  //===============================================
  const ignicaoOptions = [
    { value: "tudo", label: "Tudo" },
    { value: "1", label: "Ligado" },
    { value: "0", label: "Desligado" }
  ];


  //função conversao tabela e mapa (curso = direção)
  function converterCurso(curso, tipo = "sigla") {

    const direcoes = [
      { sigla: "N", nome: "Norte" },
      { sigla: "NE", nome: "Nordeste" },
      { sigla: "L", nome: "Leste" },
      { sigla: "SE", nome: "Sudeste" },
      { sigla: "S", nome: "Sul" },
      { sigla: "SO", nome: "Sudoeste" },
      { sigla: "O", nome: "Oeste" },
      { sigla: "NO", nome: "Noroeste" }
    ];

    const direcao = direcoes[parseInt(curso)];

    if (!direcao) return "-";

    return tipo === "nome" ? direcao.nome : direcao.sigla;

  }



  //=============================
  //COLUNAS DA TABELA
  //===========================
  const columnsPosicao = [

    {
      field: "placa", headerName: "Placa", width: 90,
      headerAlign: "center",
      align: "center",
      sortable: false,

    },

    {
      field: "posicao_em", headerName: "Data/Hora", width: 160, renderCell: (params) =>
        format(new Date(params.row.posicao_em), "dd/MM/yyyy | HH:mm:ss"),
      sortable: false,

    },

    {
      field: "nome", headerName: "Descrição", width: 160,
      headerAlign: "center",
      align: "center",

      sortable: false,
    },



    {
      field: "endereco", headerName: "Endereço", width: 420,
      headerAlign: "center",
      align: "center",
      sortable: false,
      flex: 1,
    },


    {
      field: "curso", headerName: "Direção", width: 80, headerAlign: "center",
      align: "center",
      sortable: false,


      renderCell: (params) =>
        converterCurso(params.row.curso)
    },

    {
      field: "velocidade", headerName: "KM/h", width: 80, headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) =>
        `${params.row.velocidade} Km/h`
    },



    // coluna status tabela 
    {
      field: "status",
      headerName: "Status",
      width: 260,
      headerAlign: "center",
      align: "center",
      flex: 1,

      sortable: false,
      filterable: false,
      renderCell: (params) => {

        const ignicao = params.row.ignicao;
        const bloqueio = params.row.bloqueio;
        const sirene = params.row.sirene;
        const lat = params.row.lat;
        const lon = params.row.lon;
        const satelites = params.row.satelites;
        const bateria = Number(params.row.bateria).toFixed(1);

        const handleCenter = () => {
          if (!mapRef.current) return;

          const posicao = {
            lat: Number(lat),
            lng: Number(lon),
          };

          mapRef.current.panTo(posicao);
          mapRef.current.setZoom(19);

          mapContainerRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          const pulse = new window.google.maps.Circle({
            map: mapRef.current,
            center: posicao,

            radius: 2,

            strokeColor: "#0F73B2",
            strokeOpacity: 0.9,
            strokeWeight: 2,

            fillColor: "#0F73B2",
            fillOpacity: 0.05,
          });

          let raio = 2;

          const animacao = setInterval(() => {
            raio += 0.35;

            pulse.setRadius(raio);

            pulse.setOptions({
              strokeOpacity: Math.max(0, 0.9 - raio / 18),
              fillOpacity: Math.max(0, 0.05 - raio / 200),
            });

            if (raio >= 15) {
              raio = 2;

              pulse.setRadius(2);

              pulse.setOptions({
                strokeOpacity: 0.9,
                fillOpacity: 0.05,
              });
            }
          }, 40);

          setTimeout(() => {
            clearInterval(animacao);

            let fade = 1;

            const fadeOut = setInterval(() => {
              fade -= 0.05;

              pulse.setOptions({
                strokeOpacity: fade,
                fillOpacity: fade * 0.06,
              });

              if (fade <= 0) {
                clearInterval(fadeOut);
                pulse.setMap(null);
              }
            }, 50);
          }, 6000);
        };

        const AbrirMapas = () => {
          window.open(`https://www.google.com/maps?q=${lat},${lon}`, "_blank");
        };

        const handleCopyCoords = async () => {
          const coords = `${Number(lat) || 0}, ${Number(lon) || 0}`;

          try {
            await navigator.clipboard.writeText(coords);

            await Swal.fire({
              title: "Coordenadas copiadas!",
              html: `
    <div class="inova-coordenadas-content">
      <p>As coordenadas foram copiadas para sua área de transferência.</p>

      <div class="inova-coordenadas-label">
        <i class="fas fa-location-dot"></i>
        LOCALIZAÇÃO
      </div>

      <div class="inova-coordenadas-valor">
        <span>${coords}</span>
      </div>
    </div>
  `,
              icon: "success",
              confirmButtonText: "Entendi",
              buttonsStyling: false,
              width: "390px",
              padding: "26px",

              // Evita movimentações de foco e scroll
              returnFocus: false,
              focusConfirm: false,
              heightAuto: false,
              scrollbarPadding: false,

              showClass: {
                popup: ""
              },
              hideClass: {
                popup: ""
              },
              customClass: {
                popup: "inova-coordenadas-popup",
                title: "inova-coordenadas-title",
                htmlContainer: "inova-coordenadas-html",
                confirmButton: "inova-coordenadas-confirm"
              }
            });

          } catch (err) {
            await Swal.fire({
              icon: "error",
              title: "Falha ao copiar",
              text: "Não foi possível copiar as coordenadas.",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#dc2626"
            });
          }
        };

        return (
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "6px",
            width: "100%",
            height: "100%",
          }}>


            {/* BATERIA */}
            <Tooltip
              title={`Bateria: ${bateria}`}
            >
              <img
                src={bateria <= 5 ? BateriaVermelha : bateria < 9 ? BateriaAmarela : BateriaVerde}
                width={18}
                height={18}

              />
            </Tooltip>



            {/* IGNIÇÃO */}
            <Tooltip
              title={`Iginição: ${ignicao === 1 ? "Ligado" : "Desligado"}`}
            >
              <img
                src={ignicao === 1 ? ChaveOn : ChaveOff}
                width={18}
                height={18}

              />
            </Tooltip>

            {/* BLOQUEIO */}
            <Tooltip
              title={`Bloqueio: ${bloqueio === 1 ? "Ativo" : "Inativo"}`}
              arrow

            >
              <img
                src={bloqueio === 1 ? BloqueioOn : BloqueioOff}
                width={18}
                height={18}

              />
            </Tooltip>

            {/* SIRENE */}
            <Tooltip
              title={`Sirene: ${sirene === 1 ? "Ativa" : "Inativa"}`}
              arrow

            >
              <img
                src={sirene === 1 ? SireneOn : SireneOff}
                width={18}
                height={18}

              />
            </Tooltip>

            {/* SATELITE */}
            <Tooltip
              title={
                satelites < 4
                  ? `Sem sinal (${satelites} satélites)`
                  : satelites < 6
                    ? `Sinal fraco (${satelites} satélites)`
                    : `Sinal forte (${satelites} satélites)`
              }
            >
              <span>
                {satelites < 4 ? (
                  <MdGpsOff
                    size={18}
                    style={{ color: "#EF4444" }}
                  />
                ) : satelites < 6 ? (
                  <MdGpsFixed
                    size={18}
                    style={{ color: "#F59E0B" }}
                  />
                ) : (
                  <MdGpsFixed
                    size={18}
                    style={{ color: "#22C55E" }}
                  />
                )}
              </span>
            </Tooltip>

            {/* MAPA */}
            <button onClick={handleCenter}>
              <Tooltip
                title="Mostrar no Mapa"
                arrow
              ><img src={Pin} width={20} height={20} /></Tooltip>


            </button>


            {/* ABRRIR NO GOOGLE MAPS */}
            <Tooltip
              title="Abrir no Google Maps"
              arrow
            >
              <button onClick={AbrirMapas}>

                <FaMap size={18} />

              </button>
            </Tooltip>

            {/* COPIAR COORDENADAS */}
            <Tooltip
              title="Copiar coordenadas"
              arrow

            >
              <button onClick={handleCopyCoords}>
                <IoIosCopy size={18} />
              </button>
            </Tooltip>

          </div>
        );
      }
    }

  ];
  const columnsMotorista = columnsPosicao.map(col => ({ ...col }));

  const indexDirecao = columnsMotorista.findIndex(
    (col) => col.field === "endereco"
  );

  columnsMotorista.splice(indexDirecao, 0, {
    field: "motora",
    headerName: "Motorista",
    width: 300,
    headerAlign: "center",
    align: "center",
    sortable: false,

    renderCell: (params) => {

      const motorista = params.row.motora;

      if (!motorista) {

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <span
              style={{

                color: "#DC2626",
                borderRadius: "999px",
                padding: "3px 10px",
                fontSize: "12px",
                fontWeight: 600,
                letterSpacing: "0.3px",
                fontStyle: "italic",
              }}
            >
              N/A
            </span>
          </div>
        );

      }

      return (
        <span className="relatorio-motorista-nome">
          {motorista}
        </span>
      );
    },
  });




  // total de posições retornadas

  // Função que calcula a distância entre duas coordenadas GPS
  // utilizando latitude e longitude (fórmula de Haversine)
  function calcularDistancia(lat1, lon1, lat2, lon2) {

    // Raio médio da Terra em quilômetros
    const R = 6371;

    // Calcula a diferença entre as latitudes
    // Convertendo para radianos (Math.PI / 180)
    const dLat = (lat2 - lat1) * Math.PI / 180;

    // Calcula a diferença entre as longitudes
    // Também convertendo para radianos
    const dLon = (lon2 - lon1) * Math.PI / 180;

    // Parte principal da fórmula de Haversine
    // Calcula a distância considerando a curvatura da Terra
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) *
      Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

    // Calcula o ângulo central entre os dois pontos
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    // Retorna a distância final em quilômetros
    return R * c;
  }


  const kmTotal = [...posicoes]
    .sort((a, b) => new Date(a.posicao_em) - new Date(b.posicao_em))
    .reduce((total, atual, index, array) => {

      if (index === 0) return total;

      const anterior = array[index - 1];

      return total + calcularDistancia(
        Number(anterior.lat),
        Number(anterior.lon),
        Number(atual.lat),
        Number(atual.lon)
      );

    }, 0);

  //PRELOADER PARA CARREGAMENTO
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  // Controla o scroll da página durante o carregamento
  useEffect(() => {
    if (loading) {
      document.body.style.overflow = "hidden";
    } else {
      const timer = setTimeout(() => {
        document.body.style.overflow = "auto";
      }, 800); // delay do scroll

      return () => clearTimeout(timer);
    }
  }, [loading]);



  //PAGINAÇÃO 
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0
  });


  //==================
  //TEMA 
  //=================

  const theme = createTheme({
    palette: {
      mode: "dark",
      background: {
        default: "#0b1e2d",
        paper: "#0b1e2d"
      },
      text: {
        primary: "#ffffff",
        secondary: "#cbd5e1"
      }
    },

    components: {

      /* ================= PAPER (menus / dropdowns) ================= */
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: "#0b1e2d",
            color: "#ffffff"
          }
        }
      },

      /* ================= MENU ================= */
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: "#0b1e2d",
            color: "#ffffff",
            border: "1px solid #1e4f63"
          }
        }
      },

      /* ================= MENU ITEM ================= */
      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: "#ffffff",
            fontSize: "14px",

            "&.Mui-selected": {
              backgroundColor: "#1976d2",
              color: "#ffffff"
            },

            "&:hover": {
              backgroundColor: "#1e4f63"
            }
          }
        }
      },

      /* ================= DATAGRID ================= */
      MuiDataGrid: {
        styleOverrides: {
          root: {
            border: "1px solid #1e4f63",
            color: "#333333",
          },

          columnSeparator: {
            display: "none",
          },

          columnHeader: {
            "&:focus, &:focus-within": {
              outline: "none",
            },
          },

          cell: {
            "&:focus, &:focus-within": {
              outline: "none",
            },
          },
        }
      },

      /* ================= PAGINATION ================= */
      MuiTablePagination: {
        styleOverrides: {
          root: {
            background: "#12384d",
            color: "#fff",
          },

          toolbar: {
            background: "#12384d",
            minHeight: "58px",
          },

          displayedRows: {
            color: "#fff",
            fontWeight: 500,
          },

          selectLabel: {
            color: "#fff",
            fontWeight: 500,
          },

          select: {
            color: "#fff",
          },

          actions: {
            color: "#fff",
          },
        },
      },

    }
  });


  const scrollToMap = () => {
    if (!mapContainerRef.current) return;

    const yOffset = -80; //  ajusta  (altura do topo/navbar)
    const y =
      mapContainerRef.current.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;

    window.scrollTo({
      top: y,
      behavior: "smooth"
    });
  };



  //ESTILO DO FORM 
  const selectDarkStyles = {
    control: (base, state) => ({
      ...base,

      minHeight: "42px",
      height: "42px",

      backgroundColor: "#0d1f2e",

      borderColor: state.isFocused
        ? "#2f7d69"
        : "#275364",

      borderRadius: "8px",

      boxShadow: state.isFocused
        ? "0 0 0 1px rgba(47, 125, 105, 0.35)"
        : "none",

      cursor: "pointer",

      "&:hover": {
        borderColor: "#2f7d69",
      },
    }),

    valueContainer: (base) => ({
      ...base,

      height: "42px",
      padding: "0 12px",
    }),

    singleValue: (base) => ({
      ...base,

      color: "#f1f5f7",
      fontSize: "14px",
    }),

    placeholder: (base) => ({
      ...base,

      color: "#8fa3af",
      fontSize: "14px",
    }),

    input: (base) => ({
      ...base,

      color: "#fff",
      fontSize: "14px",
    }),

    indicatorsContainer: (base) => ({
      ...base,

      height: "42px",
    }),

    dropdownIndicator: (base, state) => ({
      ...base,

      color: state.isFocused
        ? "#6baa42"
        : "#718a98",

      padding: "8px",

      transition: "all 0.2s ease",

      "&:hover": {
        color: "#6baa42",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    menu: (base) => ({
      ...base,

      marginTop: "4px",

      backgroundColor: "#0b1e2d",

      border: "1px solid #275364",

      borderRadius: "8px",

      overflow: "hidden",

      boxShadow:
        "0 10px 30px rgba(0, 0, 0, 0.35)",

      zIndex: 99999,
    }),

    menuList: (base) => ({
      ...base,

      padding: "4px",

      maxHeight: "220px",

      // Firefox
      scrollbarWidth: "thin",
      scrollbarColor: "#365665 #0b1e2d",

      // Chrome / Edge
      "&::-webkit-scrollbar": {
        width: "7px",
      },

      "&::-webkit-scrollbar-track": {
        background: "#0b1e2d",
        borderRadius: "10px",
      },

      "&::-webkit-scrollbar-thumb": {
        background: "#365665",
        borderRadius: "10px",
      },

      "&::-webkit-scrollbar-thumb:hover": {
        background: "#4a6c7c",
      },
    }),

    option: (base, state) => ({
      ...base,

      backgroundColor: state.isSelected
        ? "#6baa42"
        : state.isFocused
          ? "#142f3f"
          : "transparent",

      color: state.isSelected
        ? "#ffffff"
        : "#e5edf1",

      fontSize: "14px",

      padding: "10px 12px",

      borderRadius: "5px",

      cursor: "pointer",

      transition: "background-color 0.15s ease",

      "&:active": {
        backgroundColor: "#5d9639",
      },
    }),

    menuPortal: (base) => ({
      ...base,

      zIndex: 99999,
    }),
  };


  //PLACHEOLDER 
  const filterOption = (option, inputValue) => {
    const texto = inputValue.toLowerCase();

    return (
      option.data.placa.toLowerCase().includes(texto) ||
      option.data.nome.toLowerCase().includes(texto)
    );
  };
  return (
    <div className="relatorio-page tema-claro">
      <ThemeProvider theme={theme}>

        <Preloader
          show={loading}
          text={loadingText}
          customClass={modo === "ROTA" ? "preloader-mapa" : "naorodar"}
        />

        <div className="relatorio-container relatorio-container-claro">

          <nav className="relatorio-card">

            <div className="relatorio-content">

              {/* =====================================================
          TÍTULO
          ===================================================== */}

              <div className="relatorio-header">

                <div className="relatorio-header-content">

                  <div className="relatorio-header-icon">
                    <TbReportAnalytics size={18} />
                  </div>

                  <div>

                    <span className="relatorio-overline">
                      INOVA RASTREAMENTO
                    </span>

                    <h4 className="relatorio-titulo">
                      {titulos[tipo] || "Relatório"}
                    </h4>

                  </div>

                </div>

              </div>


              {/* =====================================================
          FORMULÁRIO
          ===================================================== */}

              <form
                className="relatorio-form"
                onSubmit={handleSubmit}
              >

                {/* =================================================
            VEÍCULO
            ================================================= */}

                <section className="relatorio-section">

                  <div className="relatorio-section-header">
                    <span className="relatorio-section-number">
                      01
                    </span>

                    <div>
                      <span className="relatorio-section-title">
                        Veículo
                      </span>

                      <span className="relatorio-section-description">
                        Selecione o veículo para consultar
                      </span>
                    </div>
                  </div>


                  <div className="row">

                    <div className="col-md-6">

                      <label className="form-label relatorio-label">
                        Placa
                      </label>

                      <Select
                        className="basic-single"
                        classNamePrefix="select"

                        value={placa}
                        inputValue={inputValue}

                        filterOption={filterOption}

                        onInputChange={(value, { action }) => {

                          if (action === "input-change") {
                            setInputValue(value);
                          }

                        }}

                        onChange={(selectedOption) => {

                          setPlaca(selectedOption);
                          setInputValue("");

                        }}

                        options={marcadores.map((marcador) => ({
                          value: marcador.placa,
                          label: marcador.placa,
                          placa: marcador.placa,
                          nome: marcador.nome,
                        }))}

                        formatOptionLabel={(option) => (
                          <div className="placa-option">

                            <div className="placa-option-placa">
                              {option.placa}
                            </div>

                            <div className="placa-option-nome">
                              {option.nome}
                            </div>

                          </div>
                        )}

                        placeholder="Buscar por placa ou nome"

                        isClearable
                      />

                    </div>

                  </div>

                </section>


                {/* =================================================
            PERÍODO
            ================================================= */}

                <section className="relatorio-section">

                  <div className="relatorio-section-header">

                    <span className="relatorio-section-number">
                      02
                    </span>

                    <div>
                      <span className="relatorio-section-title">
                        Período
                      </span>

                      <span className="relatorio-section-description">
                        Defina o intervalo da consulta
                      </span>
                    </div>

                  </div>



                  <div className="row">

                    {/* DE */}

                    <div className="col-md-3">

                      <label className="form-label relatorio-label">
                        Data inicial
                      </label>

                      <DatePicker
                        selected={
                          de
                            ? new Date(`${de}T00:00:00`)
                            : new Date(`${hoje}T00:00:00`)
                        }

                        onChange={(date) => {
                          if (!date) {
                            setDe("");
                            return;
                          }

                          const ano = date.getFullYear();
                          const mes = String(date.getMonth() + 1).padStart(2, "0");
                          const dia = String(date.getDate()).padStart(2, "0");

                          setDe(`${ano}-${mes}-${dia}`);
                        }}

                        dateFormat="dd/MM/yyyy"

                        className="form-control relatorio-input"

                        name="de"

                        placeholderText="DD/MM/AAAA"

                        locale={ptBRDateFns}

                        showPopperArrow={false}

                        popperPlacement="bottom-start"
                        popperProps={{
                          strategy: "fixed",
                        }}
                        showMonthDropdown
                        dropdownMode="select"

                      />

                    </div>


                    {/* HORA DE */}

                    <div className="col-md-3">

                      <label className="form-label relatorio-label">
                        Hora inicial
                      </label>

                      <input
                        className={`form-control relatorio-input ${erroHoraDe ? "relatorio-input-erro" : ""
                          }`}
                        type="text"
                        name="horaDe"
                        inputMode="numeric"
                        maxLength={5}
                        placeholder="00:00"
                        value={horaDe || ""}

                        onChange={(e) => {
                          let valor = e.target.value.replace(/\D/g, "");

                          valor = valor.slice(0, 4);

                          // ==========================================
                          // VALIDA HORAS
                          // ==========================================

                          if (valor.length >= 2) {
                            const horas = Number(valor.slice(0, 2));

                            if (horas > 23) {
                              setErroHoraDe(
                                "Informe um horário entre 00:00 e 23:59."
                              );

                              return;
                            }
                          }

                          // ==========================================
                          // VALIDA MINUTOS
                          // ==========================================

                          if (valor.length === 4) {
                            const minutos = Number(valor.slice(2, 4));

                            if (minutos > 59) {
                              setErroHoraDe(
                                "Informe um horário entre 00:00 e 23:59."
                              );

                              return;
                            }
                          }

                          // Remove mensagem quando estiver válido
                          setErroHoraDe("");

                          // ==========================================
                          // FORMATA HH:mm
                          // ==========================================

                          if (valor.length >= 3) {
                            valor =
                              valor.slice(0, 2) +
                              ":" +
                              valor.slice(2);
                          }

                          setHoraDe(valor);
                        }}

                        onBlur={() => {
                          if (!horaDe) {
                            setErroHoraDe("");
                            return;
                          }

                          let valor = horaDe.replace(/\D/g, "");

                          if (valor.length === 1) {
                            valor = `0${valor}00`;
                          } else if (valor.length === 2) {
                            valor = `${valor}00`;
                          } else if (valor.length === 3) {
                            valor = `0${valor}`;
                          }

                          if (valor.length === 4) {
                            let horas = Number(valor.slice(0, 2));
                            let minutos = Number(valor.slice(2, 4));

                            // Segurança adicional
                            horas = Math.min(Math.max(horas, 0), 23);
                            minutos = Math.min(Math.max(minutos, 0), 59);

                            setHoraDe(
                              `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`
                            );

                            setErroHoraDe("");
                          }
                        }}
                      />

                      {erroHoraDe && (
                        <small
                          style={{
                            display: "block",
                            marginTop: "5px",
                            color: "#ef6b73",
                            fontSize: "10px",
                            lineHeight: "1.3",
                          }}
                        >
                          {erroHoraDe}
                        </small>
                      )}

                    </div>


                    {/* ATÉ */}

                    <div className="col-md-3">

                      <label className="form-label relatorio-label">
                        Data final
                      </label>

                      <DatePicker
                        selected={
                          ate
                            ? new Date(`${ate}T00:00:00`)
                            : new Date(`${hoje}T00:00:00`)
                        }

                        onChange={(novaDataObj) => {
                          if (!novaDataObj) {
                            setAte("");
                            return;
                          }

                          const ano = novaDataObj.getFullYear();
                          const mes = String(novaDataObj.getMonth() + 1).padStart(2, "0");
                          const dia = String(novaDataObj.getDate()).padStart(2, "0");

                          const novaData = `${ano}-${mes}-${dia}`;

                          // ==========================================
                          // DATA INICIAL
                          // ==========================================

                          const inicio = new Date(`${de}T00:00:00`);
                          const fim = new Date(`${novaData}T00:00:00`);

                          // ==========================================
                          // NÃO PODE SER MENOR QUE "DE"
                          // ==========================================

                          if (fim < inicio) {
                            setAte(de);
                            return;
                          }

                          // ==========================================
                          // LIMITE DE 31 DIAS
                          // ==========================================

                          const diff =
                            (fim - inicio) /
                            (1000 * 60 * 60 * 24);

                          const LIMITE_DIAS = 31;

                          if (diff > LIMITE_DIAS) {
                            const novaDataFinal = new Date(inicio);

                            novaDataFinal.setDate(
                              novaDataFinal.getDate() + LIMITE_DIAS
                            );

                            const anoFinal = novaDataFinal.getFullYear();
                            const mesFinal = String(
                              novaDataFinal.getMonth() + 1
                            ).padStart(2, "0");
                            const diaFinal = String(
                              novaDataFinal.getDate()
                            ).padStart(2, "0");

                            setAte(
                              `${anoFinal}-${mesFinal}-${diaFinal}`
                            );

                            return;
                          }

                          setAte(novaData);
                        }}

                        dateFormat="dd/MM/yyyy"

                        className="form-control relatorio-input"

                        name="ate"

                        placeholderText="DD/MM/AAAA"

                        locale={ptBRDateFns}

                        showPopperArrow={false}

                        popperPlacement="bottom-start"
                        popperProps={{
                          strategy: "fixed",
                        }}
                        showMonthDropdown
                        dropdownMode="select"
                      />

                    </div>


                    {/* HORA ATÉ */}

                    <div className="col-md-3">

                      <label className="form-label relatorio-label">
                        Hora final
                      </label>

                      <input
                        className={`form-control relatorio-input ${erroHoraAte ? "relatorio-input-erro" : ""
                          }`}
                        type="text"
                        name="horaAte"
                        inputMode="numeric"
                        maxLength={5}
                        placeholder="00:00"
                        value={horaAte}
                        onChange={(e) => {
                          let valor = e.target.value.replace(/\D/g, "");

                          // Permite apagar completamente
                          if (valor.length === 0) {
                            setHoraAte("");
                            setErroHoraAte("");
                            return;
                          }

                          valor = valor.slice(0, 4);

                          // Valida horas
                          if (valor.length >= 2) {
                            const horas = Number(valor.slice(0, 2));

                            if (horas > 23) {
                              setErroHoraAte(
                                "Informe um horário entre 00:00 e 23:59."
                              );
                              return;
                            }
                          }

                          // Valida minutos
                          if (valor.length === 4) {
                            const minutos = Number(valor.slice(2, 4));

                            if (minutos > 59) {
                              setErroHoraAte(
                                "Informe um horário entre 00:00 e 23:59."
                              );
                              return;
                            }
                          }

                          setErroHoraAte("");

                          // Insere ":" automaticamente
                          if (valor.length >= 3) {
                            valor =
                              valor.slice(0, 2) +
                              ":" +
                              valor.slice(2);
                          }

                          setHoraAte(valor);
                        }}
                        onBlur={() => {
                          // Se deixou vazio, volta para 23:59
                          if (!horaAte) {
                            setHoraAte("23:59");
                            setErroHoraAte("");
                            return;
                          }

                          let valor = horaAte.replace(/\D/g, "");

                          if (valor.length === 1) {
                            valor = `0${valor}00`;
                          } else if (valor.length === 2) {
                            valor = `${valor}00`;
                          } else if (valor.length === 3) {
                            valor = `0${valor}`;
                          }

                          if (valor.length === 4) {
                            let horas = Number(valor.slice(0, 2));
                            let minutos = Number(valor.slice(2, 4));

                            horas = Math.min(Math.max(horas, 0), 23);
                            minutos = Math.min(Math.max(minutos, 0), 59);

                            setHoraAte(
                              `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`
                            );

                            setErroHoraAte("");
                          }
                        }}
                      />



                      {erroHoraAte && (
                        <small
                          style={{
                            display: "block",
                            marginTop: "5px",
                            color: "#ef6b73",
                            fontSize: "10px",
                            lineHeight: "1.3",
                          }}
                        >
                          {erroHoraAte}
                        </small>
                      )}

                    </div>

                  </div>

                </section>


                {/* =================================================
            FILTROS
            ================================================= */}

                <section className="relatorio-section">

                  <div className="relatorio-section-header">

                    <span className="relatorio-section-number">
                      03
                    </span>

                    <div>
                      <span className="relatorio-section-title">
                        Filtros
                      </span>

                      <span className="relatorio-section-description">
                        Refine os dados do relatório
                      </span>
                    </div>

                  </div>


                  <div className="row">

                    {/* INTERVALO */}

                    <div className="col-md-4">

                      <label className="form-label relatorio-label">
                        Intervalo de posição
                      </label>

                      <Select
                        className="basic-single"
                        classNamePrefix="select"


                        options={intervaloOptions}

                        placeholder="Selecione"

                        value={intervaloOptions.find(
                          (opt) => opt.value === intervaloDeMin
                        )}

                        onChange={(selectedOption) =>
                          setIntervaloDeMin(selectedOption?.value)
                        }

                        menuPortalTarget={document.body}
                        menuPosition="fixed"

                        isSearchable={false}

                        noOptionsMessage={() => "Nenhuma opção"}
                      />

                    </div>


                    {/* IGNIÇÃO */}

                    <div className="col-md-4">

                      <label className="form-label relatorio-label">
                        Ignição
                      </label>

                      <Select
                        className="basic-single"
                        classNamePrefix="select"

                        options={ignicaoOptions}

                        placeholder="Selecione"

                        value={ignicaoOptions.find(
                          (opt) => opt.value === ignicao
                        )}

                        onChange={(selectedOption) =>
                          setIgnicao(selectedOption?.value)
                        }

                        isClearable

                        menuPortalTarget={document.body}
                        menuPosition="fixed"

                        isSearchable={false}

                        noOptionsMessage={() => "Nenhuma opção"}
                      />

                    </div>


                    {/* VELOCIDADE */}

                    <div className="col-md-4">

                      <label className="form-label relatorio-label">
                        Velocidade mínima
                      </label>

                      <div className="relatorio-input-suffix">

                        <input
                          type="number"
                          min="0"
                          className="form-control relatorio-input"
                          value={velocidade}
                          onChange={(e) =>
                            setVelocidade(e.target.value)
                          }
                        />

                        <span>
                          km/h
                        </span>

                      </div>

                    </div>

                  </div>

                </section>


                {/* =================================================
            AÇÕES
            ================================================= */}

                <div className="relatorio-actions">

                  <div className="relatorio-actions-info">

                    <span>
                      Ações do relatório
                    </span>

                    <small>
                      Escolha o formato desejado
                    </small>

                  </div>


                  <div className="relatorio-buttons">

                    {/* EXCEL */}


                    <button
                      type="button"
                      className={`relatorio-btn btn-excel ${!placa?.value ? "btn-excel--disabled" : ""
                        }`}
                      onClick={() => handleSubmit("Excel")}
                      disabled={!placa?.value || acaoCarregando !== null}
                    >
                      {acaoCarregando === "Excel" ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                          <span>Carregando...</span>
                        </>
                      ) : (
                        <>
                          <RiFileExcel2Line size={19} />
                          <span>Excel</span>
                        </>
                      )}
                    </button>



                    {/* PDF */}


                    <button
                      type="button"
                      className={`btn btn-outline-danger relatorio-btn btn-pdf ${!placa?.value ? "btn-pdf--disabled" : ""
                        }`}
                      onClick={() => handleSubmit("PDF")}
                      disabled={!placa?.value || acaoCarregando !== null}
                    >
                      {acaoCarregando === "PDF" ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                          <span>Carregando...</span>
                        </>
                      ) : (
                        <>
                          <FaRegFilePdf size={20} />
                          <span>PDF</span>
                        </>
                      )}
                    </button>


                    {/* ROTA */}


                    <button
                      type="button"
                      className={`relatorio-btn btn-rota ${!placa?.value ? "btn-rota--disabled" : ""
                        }`}
                      onClick={(e) => handleSubmit("ROTA", e)}
                      disabled={!placa?.value || acaoCarregando !== null}
                    >
                      {acaoCarregando === "ROTA" ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                          <span>Carregando...</span>
                        </>
                      ) : (
                        <>
                          <TbGps size={19} />
                          <span>Visualizar rota</span>
                        </>
                      )}
                    </button>




                  </div>

                </div>

              </form>

            </div>

          </nav>

        </div>

        {/* MAPA */}

        <div className="mapa-wrapper">

          <div className="mapa-header">


          </div>


          <div
            id="map"
            className="mapa-relatorioPosicao"
            ref={mapContainerRef}
          >

            <Preloader
              show={loading}
              text={loadingText}
              customClass={
                modo === "ROTA"
                  ? "preloader-mapa"
                  : ""
              }
            />

          </div>

        </div>

        {/* TABELA */}
        <div className="container-Muitable-relatorioposicao">

          <DataGrid

            className="tabela-posicoes"

            disableColumnMenu
            disableColumnFilter
            disableColumnSorting

            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "linha-par"
                : "linha-impar"
            }

            localeText={{
              ...ptBR.components.MuiDataGrid.defaultProps.localeText,
              noRowsLabel: "Não existem posições registradas no momento."
            }}

            rows={posicoes.map((row, index) => ({
              ...row,
              id: row.id ?? index
            }))}

            columns={
              tipo === "motorista"
                ? columnsMotorista
                : columnsPosicao
            }

            pagination

            pageSizeOptions={[
              100,
              20,
              50,
              100,
              {
                value: -1,
                label: "Todos",
              },
            ]}

            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 100,
                },
              },
            }}

            slots={{
              footer: () => (
                <CustomFooter
                  kmTotal={kmTotal}
                />
              ),
            }}

            slotProps={{
              pagination: {
                labelRowsPerPage: "Dados por página",
                SelectProps: {
                  MenuProps: {
                    disableScrollLock: true,
                  },
                },
              },
            }}
          />

        </div>

      </ThemeProvider>
    </div>
  );
}

export default Posicao;
